import { render, staticRenderFns } from "./NewAddTask.vue?vue&type=template&id=27a1b28c&"
import script from "./NewAddTask.vue?vue&type=script&lang=js&"
export * from "./NewAddTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports